import { ConfigurationJudicialZod } from '@onr/schema'
import { doc, type FirestoreDataConverter, getFirestore } from 'firebase/firestore'
import { type z } from 'zod'

import { ErrorWithSentryCaptureContext } from '@/sentry/ErrorWithSentryCaptureContext.ts'

export type ConfigurationJudicialSnapshotData = z.infer<typeof ConfigurationJudicialZod>

export const DEFAULT_JUDICIAL_CONFIGURATION = ConfigurationJudicialZod.parse({})

const ConfigurationJudicialConverter: FirestoreDataConverter<ConfigurationJudicialSnapshotData> = {
  toFirestore: (data) => data,
  fromFirestore: (snapshot, options) => {
    const result = ConfigurationJudicialZod.safeParse(snapshot.data(options))
    if (!result.success) {
      throw new ErrorWithSentryCaptureContext(
        `Invalid Configuration Judicial ${snapshot.id}`,
        {
          tags: { 'firestore.zod': 'configurations' },
          fingerprint: ['firestore', 'zod', 'configurations'],
          extra: { data: snapshot.data(options), document: { path: snapshot.ref.path } },
        },
        { cause: result.error }
      )
    }
    return result.data
  },
}

export const judicialConfigurationDocument = () =>
  doc(getFirestore(), 'configurations/Judicial').withConverter(ConfigurationJudicialConverter)
